// extracted by mini-css-extract-plugin
export default {"container":"OutletsListMW_container__QgH1c","title":"OutletsListMW_title__H3iif"};